import React, { useEffect, useState } from 'react';
import './styles.css';

type OutcomeItem = {
  id: string;
  icon: string;
  tone:
    | 'cooperate'
    | 'low'
    | 'warning'
    | 'advantage'
    | 'equal'
    | 'market';
  setup: string;
  consequence: string;
};

const OUTCOMES: OutcomeItem[] = [
  {
    id: 'both-lot',
    icon: '🤝',
    tone: 'cooperate',
    setup: 'Both invest a lot',
    consequence: 'Both earn more.',
  },
  {
    id: 'both-little',
    icon: '↘️',
    tone: 'low',
    setup: 'Both invest little',
    consequence: 'Both earn less.',
  },
  {
    id: 'you-more',
    icon: '⚠️',
    tone: 'warning',
    setup: 'You invest more, your partner invests less',
    consequence: 'Your partner may earn more.',
  },
  {
    id: 'you-less',
    icon: '💡',
    tone: 'advantage',
    setup: 'You invest less, your partner invests more',
    consequence: 'You may earn more.',
  },
  {
    id: 'same',
    icon: '⚖️',
    tone: 'equal',
    setup: 'You invest the same, your partner invests the same',
    consequence: 'Similar earnings.',
  },
  {
    id: 'market',
    icon: '📈',
    tone: 'market',
    setup: 'Market fluctuations',
    consequence: 'Can slightly increase or decrease your final coins.',
  },
];

const InvestmentOutcomes = () => {
  const [visibleCount, setVisibleCount] = useState(0);

  useEffect(() => {
    const timers: ReturnType<typeof setTimeout>[] = [];

    OUTCOMES.forEach((_, index) => {
      timers.push(
        setTimeout(() => {
          setVisibleCount(index + 1);
        }, 350 + index * 180)
      );
    });

    return () => {
      timers.forEach(clearTimeout);
    };
  }, []);

  return (
    <div
      className="investment-outcomes-container"
      style={{ marginBottom: 'clamp(100px, 15vh, 200px)' }}
    >
      <h2 className="investment-outcomes-title">Possible outcomes:</h2>

      <div className="investment-outcomes-grid">
        {OUTCOMES.map((outcome, index) => (
          <div
            key={outcome.id}
            className={`investment-outcome-card investment-outcome-card--${outcome.tone}${
              index < visibleCount ? ' visible' : ''
            }`}
          >
            <div className="investment-outcome-icon" aria-hidden="true">
              {outcome.icon}
            </div>
            <div className="investment-outcome-body">
              <p className="investment-outcome-setup">{outcome.setup}</p>
              <p
                className={`investment-outcome-consequence investment-outcome-consequence--${outcome.tone}`}
              >
                {outcome.consequence}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InvestmentOutcomes;
